import 'submodules/responsivestyles/src/less/buying.less'
// Styles
import 'submodules/responsivestyles/src/less/payments.less'
// Components
import Form from 'common/components/form/new-form'
import { Modal } from 'components/modal'
// HOCs
import withPage from 'hoc/page'
import withStripe from 'hoc/stripe'
// Modules
import { DI } from 'modules'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import HasPass from '../payment/has-pass'
import Billing from './common/billing'
import License from './common/license'
import Method from './common/method'
// Hooks
import { PAYMENT_TYPE, usePayment } from './payment.hooks'
import Sidebar from './sidebar'
import PaymentEmail from 'pages/business/payment-new/common/email'
import ModalOTP from 'pages/business/payment-new/common/modalOTP'
import SetUpAccount from 'pages/business/payment-new/common/setUpAccount'

// @todo - наследие react-fields-validator
// либа напрямую меняет пропсы родителя, что мутабельно и очень плохо
// переехать на что-то другое (например: https://react-hook-form.com/)
// eslint-disable-next-line prefer-const
let PaymentValidator = () => {}

const Payment = ({ common, match, user, ...props }) => {
  // Setup
  const { searchParams, strings } = common

  const prefix = 'page.payment'
  const { type } = match.params
  const isVideos = type === PAYMENT_TYPE.VIDEO
  let title = isVideos
    ? strings[`${prefix}.title.video`]
    : strings[`${prefix}.title.video.branded`]

  // Data
  const agreementId = searchParams.agreement_id
  const {
    payload: { can_buy },
    error,
  } = user?.purchasePossibility || { payload: {}, error: null }

  // Hooks
  const {
    form,
    handleFormChange,
    handleFormSubmit,
    VATValidator,
    handleVATChange,
    isPendingPayment,
    isStep,
    isOpenOTPModal,
    handleSuccessConfirmOTP,
  } = usePayment({
    ...props,
    common,
    match,
    type,
    validator: PaymentValidator,
    user,
  })

  if (isStep !== 3 && !isVideos) {
    title = strings[`${prefix}.title.apply_pass`]
  }

  if (searchParams.plan && !can_buy && !error) {
    return <HasPass />
  }

  const hasAgr = Number.isInteger(agreementId)

  return (
    <>
      <Helmet>
        <title>
          {title} | {strings['site.title']}
        </title>
      </Helmet>

      <Form onChange={handleFormChange} onSubmit={handleFormSubmit}>
        <section className="content">
          <div className="wrap wrap--high">
            <div className="buying">
              <span className="buying__title">{title}</span>

              <section className="content-inner content-inner--buying">
                {isStep < 2 && (
                  <PaymentEmail
                    form={form}
                    onValidateForm={PaymentValidator}
                    showAction={isStep === 0}
                  />
                )}

                {isStep === 1 && (
                  <SetUpAccount form={form} onValidateForm={PaymentValidator} />
                )}

                {isStep === 2 && type === PAYMENT_TYPE.SUBSCRIPTION && (
                  <License
                    disabled={hasAgr}
                    form={form}
                    onValidateForm={PaymentValidator}
                  />
                )}

                {[PAYMENT_TYPE.VIDEO, PAYMENT_TYPE.SUBSCRIPTION].includes(
                  type
                ) &&
                  hasAgr && (
                    <>
                      <Billing
                        form={form}
                        onValidateForm={PaymentValidator}
                        onVATChange={handleVATChange}
                        validators={[VATValidator]}
                      />
                      <Method form={form} onValidateForm={PaymentValidator} />
                    </>
                  )}
              </section>

              <Sidebar
                disabled={isStep !== 2}
                pending={isPendingPayment}
                type={type}
              />
            </div>
          </div>
        </section>
      </Form>

      {isOpenOTPModal && <ModalOTP confirm={handleSuccessConfirmOTP} />}

      {isPendingPayment && (
        <Modal>
          <div className="popup-with-ico">
            <span className="popup-sending__ico" />
            <span className="popup-sending__text">
              {strings['page.members.invite_modal.sending']}
            </span>
          </div>
        </Modal>
      )}
    </>
  )
}

export default withStripe(
  withPage(
    DI(['common', 'notifications', 'taxes', 'videos', 'user', 'geodata'])(
      Payment
    ),
    {
      clear: true,
    }
  )
)
